import { Component } from '@angular/core';

@Component({
  selector: 'app-starter',
  templateUrl: './starter.component.html',
  styleUrl: './starter.component.css'
})
export class StarterComponent {

}
